module.exports = __webpack_public_path__ + "fonts/LeagueGothic-Regular-VariableFont_wdth.ttf";